import React from 'react';
import axios from 'axios';
import { Box, Button, Tooltip } from '@chakra-ui/react';

import { options } from './data';

export const AdminChecklist = ({ customer, loaded, setWake }) => {
	const { disabled, label, text } = loaded
		? {
				disabled: false,
				label: 'Загруженные документы проверены',
				text: 'All the loaded documents checks are complete',
		  }
		: {
				disabled: true,
				label: 'Новые загруженные документы пользователем не отмечены ',
				text: 'No new documents loaded by customer',
		  };

	const onClick = () => {
		axios({
			method: 'put',
			url: `/loaded`,
			data: {
				customer,
				loaded: false,
			},
			...options(),
		})
			.then(() => {
				setWake(new Date().getTime());
			})
			.catch(console.log);
	};

	return (
		<Box mt={6}>
			<Tooltip label={label} placement="bottom-start">
				<Button
					disabled={disabled}
					onClick={onClick}
					d="block"
					w="100%"
					bgColor="green.500"
					borderRadius="md"
					color="white"
					fontSize="xl"
					py="2"
					textAlign="center"
					_hover={{
						textDecoration: 'none',
					}}
				>
					{text}
				</Button>
			</Tooltip>
		</Box>
	);
};
